import instanceQuery from 'graphql/queries/supplier/PurchaseVatOnlyTransactionQuery.graphql';
import fragment from 'graphql/fragments/nominal/PostedTransactionsFragment.graphql';

const PurchaseVatOnlyTransactions = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
};

export default PurchaseVatOnlyTransactions;
